import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UIChart } from 'primeng/chart';
import { InitiateTrainingComponent } from '../initiate-training/initiate-training.component';
import { EmployeeCareerProgramService } from 'src/app/views/employee/employee-career-program/employee-career-program.service';
import { TopTrainingListDetailsComponent } from 'src/app/top-training-list-details/top-training-list-details.component';
import { TrainingsTrackerService } from '../trainings_tracker.service';
import { ToastrService } from 'ngx-toastr';
import { ExcelService } from 'src/app/services/excel-service.service';
 
@Component({
  selector: 'app-skill-index',
  templateUrl: './skill-index.component.html',
  styleUrls: ['./skill-index.component.css']
})

export class SkillIndexComponent implements OnInit, AfterViewInit {

  @Input() subCompetencyChartData: any = [];

  @Input() trainingChartData: any;

  @Input() topTrainings: any = [];
  
  @Input() serviceAreaList: any = [];
  
  @Output() trainingEmitter = new EventEmitter<any>();

  subCompetencyDistributionChartData: any;

  subComptenciesChartOptions: any;

  trainingChartOptions:any;

  legendItems: any

  legendItemsForTraining: any;

  highlightedLabel = '';

  trainingHighlightedLabel = '';

  TopListProgramId=0;

  tableData = [];

  totalTableData: any = [];

  totalRecordsArr: any = [];

  displayedColumns = [
    "checkBox",
    "employeeId",
    "firstName",
    "lastName",
    "skillType",
    "level",
    "email",
    "skills"
  ];

  proficiencyLevel = {
    1: 'Beginner',
    2: 'Intermediate'
  };

  totalRecords = 0;

  size:any = 10;

  from: any = 0;

  isAllSelected = false;

  subCompForDropDown = [];

  skillsForDropDown: any = [];

  selectedSkills:any = [];

  selectedSubCompetency:any = [];

  competencyName = '';

  filterOptions = {
    "skillType": false,
    "level": false,
  };

  filterOptionsList = {
    skillType: [
      { name: 'Up Skill', isChecked: false },
      { name: 'Cross Skill', isChecked: false }
    ],
    level: [
      { name: 'Beginner', isChecked: false },
      { name: 'Intermediate', isChecked: false },
      { name: 'Expert', isChecked: false }
    ]
  };

  tableDataForFilterOptions: any = [];

  filteredList: any = {};

  @ViewChild('chart1') chart1: UIChart;

  @ViewChild('chart2') chart2: UIChart;

  constructor(
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private empProgService: EmployeeCareerProgramService,
    private trainingService: TrainingsTrackerService,
    private toaster: ToastrService,
    private excel: ExcelService,
  ) { }

  ngOnInit() {

  }

  ngOnChanges() {
    this.prepareSubCompetencyChartData();
    this.generateCustomLegend('subCompetencyDistributionChartData', 'legendItems');
    this.generateTrainingChartData();
    this.generateCustomLegend('trainingChartData', 'legendItemsForTraining');
    this.competencyName = sessionStorage.getItem('compTitle');
    this.filteredList = this.filterOptionsList;
    if (
      this.subCompetencyChartData &&
      this.subCompetencyDistributionChartData &&
      this.subComptenciesChartOptions
    ) {
      const subComp = sessionStorage.getItem('SubcompTitle');
      if (subComp) {
       this.onLegendItemClick(subComp)
       this.cdr.detectChanges();
      }
    }
  }
  
  ngAfterViewInit(): void {
  }

  prepareSubCompetencyChartData() {
    const subCompetencyCounts = {};
    const labels = [];
    const data = [];
    this.subCompetencyChartData.forEach(employee => {
      (employee.serviceArea || []).forEach((service) => {
        if (service.experience !== 0) {
          if (subCompetencyCounts[service.serviceArea]) {
            subCompetencyCounts[service.serviceArea] += 1;
          } else {
            subCompetencyCounts[service.serviceArea] = 1;
          }
        }
      });
    });
    for (const [serviceArea, count] of Object.entries(subCompetencyCounts)) {
      labels.push(serviceArea);
      data.push(count);
    }
    this.subCompetencyDistributionChartData = {
      datasets: [{
        data: data,
        backgroundColor: this.generateColors(labels.length),
      }],
      labels: labels
    };
    this.subComptenciesChartOptions = this.getChartOptionsForSubCompetency();
  }

  processAllSelected(event) {
    this.isAllSelected = event;
    this.tableData.forEach((elem) => elem.isChecked = event);
    this.totalTableData.forEach(element => {
      if (this.tableData.some((s) => s.employeeId === element.employeeId)) {
        element.isChecked = event;
      }
    });
  }

  processCheckEvent(event, row) {
    row.isChecked = event
    this.tableData.forEach((elem) => {
      if (elem.employeeId === row.employeeId) elem.isChecked = event;
    });
    this.totalTableData.forEach((elem) => {
      if (elem.employeeId === row.employeeId) elem.isChecked = event;
    });
    this.isAllSelected = this.tableData.every((elem) => elem.isChecked);
  }

  generateTrainingChartData() {
    this.trainingChartData.datasets[0].backgroundColor = this.generateColors(
      this.trainingChartData.labels.length
    );

    this.trainingChartOptions = {
      animation: false,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          callbacks: {
            label: (context: any) => {
              const value = context.parsed || 0;
              return `${value} %`;
            }
          }
        },
      },
      responsive: false,
      maintainAspectRatio: false,
      elements: {
        arc: {
          borderWidth: (context: any) => context.chart.data.labels[context.dataIndex] === this.trainingHighlightedLabel ? 5 : 0,
          borderColor: (context: any) => context.chart.data.labels[context.dataIndex] === this.trainingHighlightedLabel ? '#7d7d7d' : '',
        },
      }
    };
  }

  getChartOptionsForSubCompetency() {
    return {
      animation: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: (context: any) => {
              const value = context.parsed || 0;
              const dataset = context.dataset.data;
              const total = dataset.reduce((previous: number, current: number) => previous + current, 0);
              const percentage = ((value / total) * 100).toFixed(2) + '%';
              return percentage;
            }
          }
        },
      },
      responsive: false,
      maintainAspectRatio: false,
      elements: {
        arc: {
          borderWidth: (context: any) => context.chart.data.labels[context.dataIndex] === this.highlightedLabel ? 5 : 0,
          borderColor: (context: any) => context.chart.data.labels[context.dataIndex] === this.highlightedLabel ? '#7d7d7d' : '',
        },
      },
    }
  }

  generateColors(count: number): string[] {
    const colors = [
      '#7DBE7D', '#ffce61', '#ff6e6e', '#ff9f40', '#4bc0c0',
      '#9966ff', '#ff66b2', '#ffcc00', '#c4e17f', '#ff6f61',
      '#6a1b9a', '#d32f2f', '#1976d2', '#388e3c', '#0288d1',
      '#f57c00', '#c2185b', '#7b1fa2', '#fbc02d', '#0288d1',
      '#795278', '#8d6e63', '#f06292', '#64b5f6', '#4db6ac',
      '#81c784', '#ffb74d', '#ba68c8', '#4ae15c', '#ff8a65',
    ];
    return colors.slice(0, count);
  }

  generateCustomLegend(chartKey, legendKey) {
    if (
      this[chartKey] &&
      this[chartKey].labels &&
      this[chartKey].datasets &&
      this[chartKey].datasets[0].backgroundColor
    ) {
      this[legendKey] = this[chartKey].labels.map((label, index) => ({
        label: label,
        color: this[chartKey].datasets[0].backgroundColor[index]
      }));
    }
  }

  onLegendItemClick(label, i = 0) {
    this.highlightedLabel = label;
    if (this.chart1) {
      this.chart1.refresh();
    }
    this.clearFilter();
    this.renderTable(label);
  }

  clearFilter() {
    Object.keys(this.filterOptions).forEach(key => {
      this.filterOptions[key] = false;
    });
    Object.keys(this.filterOptionsList).forEach(key => { 
      this.filterOptionsList[key].forEach(item => {
        item.isChecked = false;
      });
    });
  }

  onTrainingLegendItemClick(label, i) {
    this.trainingHighlightedLabel = label === this.trainingHighlightedLabel ? null : label;
    if (this.chart2) {
      this.chart2.refresh();
    }
  }
  
  OnTopTrainingListItemClick(programId) {
    let programDetails=null; 
    this.TopListProgramId =programId;
    const userid=Number(sessionStorage.getItem("EmpCareerUserID"));
    this.empProgService.getEmployeeProgramDetail(userid, programId).subscribe(async (res: any) => {
      if (res) {  
        programDetails =await res;  
      }
      const dialogRef = this.dialog.open(TopTrainingListDetailsComponent, {
      width: '1058px',
      height: '557px',
      panelClass: 'view-file',
      data: { programDetails }
    });
    }, error => {
       
    }) 
  }

  exportData() {
    if (this.totalTableData.length > 0) {
      const exportData = this.totalTableData.map((item) => {
        return {
          'Employee ID': item.employeeId,
          'First Name': item.firstName,
          'Last Name': item.lastName,
          'Skill Type': item.skillType,
          'Level': this.proficiencyLevel[item.level] ?? 'Expert',
          'Email': item.email,
          'Skills': item.skills,
        };
      });
      let fileName = 'Employees_Skill_Index';
      this.excel.exportAsExcelFile(exportData, fileName);
    } else {
      this.toaster.error('No data available to export');
    }
  }

  renderTable(label) {
    const filteredData = this.subCompetencyChartData
    this.totalRecordsArr  = filteredData;
    this.totalRecords = filteredData.length;
    this.tableDataForFilterOptions = filteredData;
    this.totalTableData = this.mapTableData(filteredData, label);
    this.subCompForDropDown = filteredData
      .map((item) => {
        return { name: item.subCompetency.trim() };
      })
      .filter((item, index, self) => index === self.findIndex((s) => s.name === item.name))
      .map((item, index) => {
        return {...item, id: index + 1};
      })
      .sort((a, b) => a.name.localeCompare(b.name));
      
    this.skillsForDropDown = [];
    this.tableData = this.totalTableData.slice(this.from, this.from ? this.from + this.size : this.size);
  }

  getPaginatorData(event) {
    this.size = event.pageSize;
    this.from = event.pageIndex * this.size;
    this.tableData = this.totalTableData.slice(this.from, this.from + this.size);
    this.isAllSelected = this.tableData.every((elem) => elem.isChecked);
  }

  isEmployeeSelcted() {
    return this.tableData.some((elem) => elem.isChecked);
  }

  openInitiateTraining() {
    const empList = this.totalTableData.filter((elem) => elem.isChecked);

    const dialogRef = this.dialog.open(InitiateTrainingComponent, {
      width: '1058px',
      height: '540px',
      panelClass: 'view-file',
      data: { empList }
    });

    dialogRef.afterClosed().subscribe((flag) => {
      if (flag) { // assign training API called successfully
        this.trainingEmitter.emit();
      }
    });
  }

  toggleSubCompDropdown(e, i) {
    if (this.selectedSubCompetency.length) {
      new Promise<void>((resolve) => {
        this.filterDataBasedOnSubCompetency();
        resolve();
      }).then(() => {
        this.skillsForDropDown = this.totalTableData
          .filter(item => this.selectedSubCompetency.some(i => i.name === item.subCompetency))
          .flatMap((elem) => elem.skillsArr.map((skill, index) => ({ name: skill.trim().replace(/\\./g, '') })))
          .filter((item, index, self) => index === self.findIndex((s) => s.name === item.name))
          .map((item, index) => {
            return { ...item, id: index + 1 };
          })
          .sort((a, b) => a.name.localeCompare(b.name));
      });
    } else {
      this.skillsForDropDown = [];
      if (this.selectedSkills.length) {
        this.filterDataBasedOnSkills();
      } else {
        this.renderTable(this.highlightedLabel);
      }
    }
  }

  toggleSkills(i) {
    if (this.selectedSkills.length) {
      this.filterDataBasedOnSkills();
    } else {
      if (this.selectedSubCompetency.length) {
        this.filterDataBasedOnSubCompetency();
      } else {
        this.renderTable(this.highlightedLabel);
      }
    }
  }

  filterDataBasedOnSubCompetency() {
    const filteredData = this.totalRecordsArr.filter(
      (item) => this.selectedSubCompetency.some((x) => x.name === item.subCompetency)
    );
    this.tableDataForFilterOptions = filteredData;
    this.totalTableData = this.mapTableData(filteredData, this.highlightedLabel);
    this.totalRecords = this.totalTableData.length;
    this.tableData = this.totalTableData.slice(this.from, this.from ? this.from + this.size : this.size);
  }

  filterDataBasedOnSkills() {
    const filteredData = this.totalRecordsArr.filter(
      (item) => this.selectedSkills.some((x) =>
        [
          ...(item.primarySkills || []).map((s) => s.skill),
          ...(item.secondarySkills || []).map((s) => s.skill)
        ].includes(x.name)
      )
    );
    this.tableDataForFilterOptions = filteredData;
    this.totalTableData = this.mapTableData(filteredData, this.highlightedLabel); 
    this.totalRecords = this.totalTableData.length;
    this.tableData = this.totalTableData.slice(this.from, this.from ? this.from + this.size : this.size);
  }

  mapTableData(data, label) {
    return data.map((item) => {
      const proficienyObj = item.serviceArea.find((service) => service.serviceArea === label);
      const primarySkills = item.primarySkills ? item.primarySkills.map(item => item.skill) : [];
      const secondarySkills = item.secondarySkills ? item.secondarySkills.map(item => item.skill) : [];
      const skills = new Set([...primarySkills, ...secondarySkills]);
      
      const serviceArea = this.serviceAreaList.find((service) =>
        service['Service Lines'] === label &&
        [...skills].some((skill) => service['Technology Stack'].split(', ').some((s) => s.trim().toLowerCase() === skill.trim().toLowerCase()))
      );
      
      let skillType = '';
      if (serviceArea) {
        skillType = 'Up Skill';
      } else {
        skillType =  'Cross Skill';
      }
      return {
        "employeeId": item.employeeId,
        "firstName": item.firstName,
        "lastName": item.lastName,
        "skillType": skillType,
        "level": skillType === 'Cross Skill'
          ? 1
          : proficienyObj && proficienyObj.proficiency
            ? proficienyObj.proficiency
            : 1,
        "email": item.email,
        "skillsArr": [...skills],
        "skills": skills && skills.size > 0 ? [...skills].join(', ') : 'Not Available',
        "subCompetency": item.subCompetency,
        "subCompetencyId": item.subCompetencyId,
      };
    }).sort((a, b) => {
      if (a.skillType !== b.skillType) {
        return a.skillType === 'Up Skill' ? -1 : 1;
      }

      if (a.skillType === 'Up Skill') {
        return a.level - b.level;
      }
      return 0;
    });
  }

  openCloseFilter(column) {
    Object.keys(this.filterOptions).forEach(key => {
      if (key !== column) {
        this.filterOptions[key] = false;
      }
    });
    this.filterOptions[column] = !this.filterOptions[column];
  }

  filterDataBasedOnFilter(column, selectedOptions) {
    this.totalTableData = this.mapTableData(this.tableDataForFilterOptions, this.highlightedLabel);
      this.totalTableData = this.totalTableData.filter(
        (item) =>
          (!selectedOptions.skillType.length ||
            selectedOptions.skillType.some((x) => x.name === item.skillType)) &&
          (!selectedOptions.level.length ||
            selectedOptions.level.some((x) =>
              this.proficiencyLevel[item.level]
                ? x.name === this.proficiencyLevel[item.level]
                : !this.proficiencyLevel[item.level] && x.name === 'Expert'))
      );
    this.totalRecords = this.totalTableData.length;
    this.tableData = this.totalTableData.slice(this.from, this.from ? this.from + this.size : this.size);
  }

  onOptionChange(event, option, column) {
    this.filterOptionsList[column].forEach((item) => {
      if (item.name === option.name) {
        item.isChecked = event;
      }
    });
    const selectedOptions: any = {};
    Object.keys(this.filterOptionsList).forEach((key) => {
      selectedOptions[key] = this.filterOptionsList[key].filter((item) => item.isChecked);
    }); 
    this.filterOptionsList[column].filter((item) => item.isChecked);
    
    if (selectedOptions.skillType.length || selectedOptions.level.length) {
      this.filterDataBasedOnFilter(selectedOptions, selectedOptions);
    } else {
      if (this.selectedSubCompetency.length || this.selectedSkills.length) {
        if (this.selectedSubCompetency.length) {
          this.filterDataBasedOnSubCompetency();
        } 
        if (this.selectedSkills.length) {
          this.filterDataBasedOnSkills();
        }
      } else {
        this.renderTable(this.highlightedLabel);
      }
    }
  }
}
